<template>
<el-dialog width="80%" :title=" '查看 ' + $t('m.planActivity.planActivity')" :visible.sync="showDialog" @close="closeDialog" :before-close="beforeClose" :close-on-click-modal="false" :append-to-body="true" v-dialogDrag>
  <el-form ref="formRef" :rules="formRules" :model="formModel" label-width="180px" size="mini">
    <el-row :gutter="20">
      <el-col :span="11">
        <el-form-item :label="$t('m.planActivity.name')" prop="name">
          <el-input v-model="formModel.name" maxlength="30" :placeholder="$t('c.form.maximumLength') + '30'" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="$t('m.planActivity.planHoldingTime')" prop="planHoldingTime">
          <el-date-picker type="month" :placeholder="$t('c.form.pleaseInput')" value-format="yyyy-MM" v-model="formModel.planHoldingTime" style="width: 100%;" readonly></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="$t('m.planActivity.activeAddress')" prop="activeAddress">
          <el-input v-model="formModel.activeAddress" maxlength="30" :placeholder="$t('c.form.maximumLength') + '30'" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="$t('m.planActivity.partners')" prop="partners">
          <el-input v-model="formModel.partners" maxlength="30" :placeholder="$t('c.form.maximumLength') + '30'" readonly></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="$t('m.planActivity.actualHoldingTime')" prop="actualHoldingTime">
          <el-date-picker type="date" :placeholder="$t('c.form.pleaseSelect')" value-format="yyyy-MM-dd" v-model="formModel.actualHoldingTime" style="width: 100%;" disabled></el-date-picker>
        </el-form-item>
      </el-col>
      <el-col :span="11">
        <el-form-item :label="$t('m.planActivity.activityType')" prop="activityType">
          <el-input v-model="formModel.activityType" maxlength="15" :placeholder="$t('c.form.maximumLength') + '15'" readonly></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="22">
        <el-form-item :label="$t('m.planActivity.content')" prop="content">
          <template>
            <vue-ueditor-wrap v-model="content" :config="myConfig"></vue-ueditor-wrap>
          </template>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row :gutter="20">
      <el-form-item style="float:right;margin-right: 10%">
        <el-button type="primary" @click="showAttachment()">附件</el-button>
        <el-button size="mini" @click.native="closeDialog()">{{ $t('c.dialog.close') }}</el-button>
      </el-form-item>
    </el-row>
  </el-form>
  <comp-plan-attachment
  v-if="attachmentDialogVisible"
  :attachmentDialogVisible.sync="attachmentDialogVisible"
  @closeDialog="closeAttachmentDialog"
  :uploadFormShow = "uploadFormShow"
  :dataId="dataId"
  >
  </comp-plan-attachment>
</el-dialog>
</template>
<script>
import {
  insertPlanActivity,
  updateAllColumnPlanActivity
} from '../../api/plan/PlanActivity';
import CompPlanAttachment from '../../comp/plan/CompPlanAttachment';
import {
  apiServerUrl
} from '@/bizConfig';
export default {
  components: {
    CompPlanAttachment, //附件展示编辑页
  },
  name: 'Ueditor',
  // 组件属性对象
  props: {
    // 同步更新父对象的属性, 是否显示该对话框
    detailDialogVisible: Boolean,
    // 来自父组件的操作类型参数
    actionOfParent: Object,
    // 当前主表行记录
    currentTableRow: Object
  },
  // 组件数据对象
  data() {
    return {
      attachmentDialogVisible:false,
      dataId:"",
      uploadFormShow:false,
      myConfig: {
        // 你的UEditor资源存放的路径,相对于打包后的index.html
        UEDITOR_HOME_URL: '/ueditor/',
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 工具栏是否可以浮动
        autoFloatEnabled: false,
        // 初始容器高度
        initialFrameHeight: 300,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 关闭自动保存
        enableAutoSave: true,
        readonly: true,
        zIndex: 9999,
        // serverUrl: apiServerUrl + "/upload/ckeditor/imageUpload"
        serverUrl: apiServerUrl + "/upload/ueditor/ueditorConfig" //暂时先用这个，不报错，根据自己业务改
      },
      content: '',
      editor: null,
      // 是否显示该对话框
      showDialog: true,
      // 表单模型
      formModel: {},
      // 当前操作类型, ACTION.NEW/ACTION.EDIT/ACTION.VIEW
      currentAction: {},
      // 表单验证规则
      formRules: {
        name: [{
          required: true,
          validator: function(rule, value, callback) {
            if (value === undefined || value === null || value.trim().length === 0) {
              callback(new Error('活动名称不能为空'));
            } else {
              callback();
            }
          }
        }],
        planHoldingTime: [{
          required: true,
          message: '计划举办时间不能为空'
        }],
        activeAddress: [{
          required: true,
          validator: function(rule, value, callback) {
            if (value === undefined || value === null || value.trim().length === 0) {
              callback(new Error('活动地址不能为空'));
            } else {
              callback();
            }
          }
        }],
        partners: [{
          required: true,
          validator: function(rule, value, callback) {
            if (value === undefined || value === null || value.trim().length === 0) {
              callback(new Error('合作方不能为空'));
            } else {
              callback();
            }
          }
        }],
        activityType: [{
          required: true,
          validator: function(rule, value, callback) {
            if (value === undefined || value === null || value.trim().length === 0) {
              callback(new Error('活动类型不能为空'));
            } else {
              callback();
            }
          }
        }],
        delete_this_line: []
      }
    };
  },
  // 页面首次加载数据
  mounted() {
    this.formModel = this.currentTableRow;
    this.currentAction = this.actionOfParent;
    if (this.currentTableRow.content !== null && this.currentTableRow.content !== undefined && this.currentTableRow.content.trim().length > 0) {
      this.content = this.currentTableRow.content;
      var ue = UE.getEditor('editor');
      if (ue) {
        ue.ready(function() {
          //不可编辑
          ue.setDisabled();
        });
      }
    }

    // this.editor = window.UE.getEditor('editor');
  },
  methods: {
    /**
     * 关闭对话框
     * @param modified 是否有更新
     */
    closeDialog(modified) {
      if (this.beforeCloseCheck()) {
        this.showDialog = false;
        // 子组件向父组件绑定的属性传值
        this.$emit('update:detailDialogVisible', false)
        if (modified) {
          this.$emit('listenToDetailDialogClose', this.currentAction)
        }
      }
    },
    /**
     * 对话框关闭前的校验
     * @returns true表示校验通过可以关闭, false表示校验失败不允许关闭
     */
    beforeCloseCheck() {
      // 你的业务校验代码
      return true;
    },
    /**
     * 对话框右上角的×关闭前事件
     * @param done 回调关闭方法
     */
    beforeClose(done) {
      if (this.beforeCloseCheck()) {
        done();
      }
    },
    //关闭附件对话框
    closeAttachmentDialog: function(action) {
      this.attachmentDialogVisible = false;
    },
    //展示附件对话框
    showAttachment() {
      this.attachmentDialogVisible = true
      this.dataId = this.formModel.id
    },
  }
}
</script>

<style lang="scss">
.ck-content {
    min-height: 260px;
    max-height: 260px;
}
// .el-form-item__content {
//   line-height: 12px;
// }
</style>
